import React, {Component} from 'react';
import {Row, Col, Card} from 'react-materialize';
import accident from "../../images/accident.png";
import slips_blue from "../../images/slips_blue.png";
import drowning from "../../images/drowning.png";
import cutting_drilling from "../../images/cutting_drilling.png";
import machinery from "../../images/machinery.png";
import fire_explosion_blue from "../../images/fire_explosion_blue.png";
import animals_blue from "../../images/animals_blue.png";
import electrocution_blue from "../../images/electrocution_blue.png";

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';



import translate from 'react-i18next';

class Acidente extends Component{



   render(){


       return(

    <Card>
        {/*ACIDENTES*/}

        <Row>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={accident} className={"img"}/> </div>

            </Col>

            <Col s={10} m={10}>

                <p>  <h5><b> <FormattedMessage id={"accident.header"} defaultMessage={"Acidente"}/></b></h5></p>
            </Col>
        </Row>

        <Row className={"valign-wrapper"}>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={slips_blue} className={"img"}/>
                </div>
            </Col>

            <Col s={10} m={10}>

                <div align="justify">

                    <p><b><FormattedMessage id={"slipping"} defaultMessage={"Deslizamentos"}/></b></p>
                    <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo"}/></b></li>
                        <p><FormattedMessage id={"slipping.text"} defaultMessage={"Os deslizamentos e quedas podem ser causados por piso molhado e escorregadio, ferramentas deixadas em passarelas e resíduos descartados no chão, como ostras e calhas abertas;"}/></p>
                        <p><FormattedMessage id={"slipping.text2"} defaultMessage={"Quedas de altura, plataformas flutuantes ou fixas."}/></p>
                        <li><b> <FormattedMessage id={"risks"} defaultMessage={"Risco/Danos à Saúde:"}/></b></li>
                        <p><FormattedMessage id={"slipping.text3"} defaultMessage={"Fraturas;"}/></p>
                        <p><FormattedMessage id={"slipping.text4"} defaultMessage={"Contusões;"}/></p>
                        <p><FormattedMessage id={"slipping.text5"} defaultMessage={"Luxações;"}/></p>
                        <p><FormattedMessage id={"slipping.text6"} defaultMessage={"Potencial de afogamento de trabalhador ferido;"}/></p>
                        <p><FormattedMessage id={"slipping.text7"} defaultMessage={"Desmaio e perda da consciência;"}/></p>
                        <p><FormattedMessage id={"slipping.text8"} defaultMessage={"Afogamentos;"}/></p>
                        <li><b><FormattedMessage id={"control"} defaultMessage={"Controle e prevenção:"}/></b></li>
                        <ul className={"browser-default"}>
                            <li><b><FormattedMessage id={"engineering"} defaultMessage={"Controles de engenharia:"}/></b></li>
                        <p><FormattedMessage id={"slipping.text9"} defaultMessage={"Piso antiderrapante;"}/></p>
                            <li><b><FormattedMessage id={"administration"} defaultMessage={"Administrativos e EPIs:"}/></b></li>
                        <p><FormattedMessage id={"slipping.text10"} defaultMessage={"Passarelas livres de obstáculos;"}/></p>
                        <p><FormattedMessage id={"slipping.text11"} defaultMessage={"Manter o chão seco;"}/></p>
                        <p><FormattedMessage id={"slipping.text12"} defaultMessage={"Calçado antiderrapante;"}/></p>
                            <p><FormattedMessage id={"slipping.text13"} defaultMessage={"Mapa de riscos e sinalização."}/></p> </ul></ul>
                </div>
            </Col>

        </Row>

        <Row className={"valign-wrapper"}>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={drowning} className={"img"}/>
                </div>
            </Col>

            <Col s={10} m={10}>

                <p><b><FormattedMessage id={"drowning"} defaultMessage={"Afogamento"}/></b></p>
                <ul className={"browser-default"}>
                    <li><b><FormattedMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo"}/></b></li>
                    <p><FormattedMessage id={"drowning.text"} defaultMessage={"Quedas no mar ou açudes;"}/></p>
                    <p><FormattedMessage id={"drowning.text2"} defaultMessage={"Falta de uso do dispositivo de flutuação pessoal"}/> (PFD);</p>
                    <p><FormattedMessage id={"drowning.text3"} defaultMessage={"Afogamento por mergulho, falta de ar e descompressão;"}/></p>
                    <li><b> <FormattedMessage id={"risks"} defaultMessage={"Risco/Danos à Saúde:"}/></b></li>
                    <p><FormattedMessage id={"drowning.text4"} defaultMessage={"Morte;"}/></p>
                    <p><FormattedMessage id={"drowning.text5"} defaultMessage={"Sequelas ocorridas pelo afogamento;"}/></p>
                    <p><FormattedMessage id={"drowning.text6"} defaultMessage={"Ingestão de água excessiva através das vias orais e respiratórias;"}/></p>
                    <p><FormattedMessage id={"drowning.text6"} defaultMessage={"Desmaios;"}/></p>
                    <p><FormattedMessage id={"drowning.text7"} defaultMessage={"Descompressão;"}/></p>
                    <li><b><FormattedMessage id={"control"} defaultMessage={"Controle e prevenção:"}/></b></li>
                    <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"engineering"} defaultMessage={"Controles de engenharia:"}/></b></li>
                    <p><FormattedMessage id={"drowning.text8"} defaultMessage={"Instalar linhas de vida flutuantes ou outros dispositivos para sair de lagoas e tanques revestidos de plástico ou de superfícies lisas ou lamacentas."}/></p>
                        <li><b><FormattedMessage id={"administration"} defaultMessage={"Administrativos e EPIs:"}/></b></li>
                    <p><FormattedMessage id={"drowning.text9"} defaultMessage={"Uso de dispositivo pessoal de flutuação (PFD) como colete salva-vidas e boia para emergência;"}/></p>
                    <p><FormattedMessage id={"drowning.text10"} defaultMessage={"Treinamento;"}/></p>
                    <p><FormattedMessage id={"drowning.text11"} defaultMessage={"Ter conhecimentos de mergulho e natação;"}/></p>
                        <p><FormattedMessage id={"drowning.text12"} defaultMessage={"Certificar-se sobre segurança no mergulho e em duplas no mínimo."}/></p> </ul></ul>


            </Col>

        </Row>

        <Row className={"valign-wrapper"}>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={cutting_drilling} className={"img"}/>
                </div>
            </Col>

            <Col s={10} m={10}>
                <div align="justify">
                    <p><b><FormattedMessage id={"cuts"} defaultMessage={"Cortes e perfurações"}/></b></p>
                    <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo"}/></b></li>
                        <p><FormattedMessage id={"cuts.text1"} defaultMessage={"Manuseio de equipamentos afiados e perfurantes;"}/></p>
                        <p><FormattedMessage id={"cuts.text2"} defaultMessage={"Utilização de rede de pesca, malhadeira, zagaia, arpão, flecha, anzol ou facas;"}/></p>
                        <p><FormattedMessage id={"cuts.text3"} defaultMessage={"Manuseio de seringa e agulha em vacinação."}/></p>
                        <li><b> <FormattedMessage id={"risks"} defaultMessage={"Risco/Danos à Saúde:"}/></b></li>
                        <p><FormattedMessage id={"cuts.text4"} defaultMessage={"Dor intensa;"}/></p>
                        <p><FormattedMessage id={"cuts.text5"} defaultMessage={"Infecções;"}/></p>
                        <p><FormattedMessage id={"cuts.text6"} defaultMessage={"Cicatrizes;"}/></p>
                        <p><FormattedMessage id={"cuts.text7"} defaultMessage={"Hemorragias;"}/></p>
                        <p><FormattedMessage id={"cuts.text8"} defaultMessage={"Perfuração com agulhas;"}/></p>
                        <li><b><FormattedMessage id={"control"} defaultMessage={"Controle e prevenção:"}/></b></li>
                        <ul className={"browser-default"}>
                            <li><b><FormattedMessage id={"elimination"} defaultMessage={"Eliminação ou substituição:"} /></b></li>
                        <p><FormattedMessage id={"cuts.text9"} defaultMessage={"Instalar equipamentos de vacinação automática."}/></p>
                            <li><b><FormattedMessage id={"engineering"} defaultMessage={"Controles de engenharia:"}/></b></li>
                        <p><FormattedMessage id={"cuts.text10"} defaultMessage={"Use mesa ondulada para imobilizar o peixe no sulco ondulado."}/></p>
                            <li><b><FormattedMessage id={"administration"} defaultMessage={"Administrativos e EPIs:"}/></b></li>
                        <p><FormattedMessage id={"cuts.text11"} defaultMessage={"Treinamento em aplicação de vacinas;"}/></p>
                        <p><FormattedMessage id={"cuts.text12"} defaultMessage={"Utilização de equipamentos de proteção individual como luvas anti-corte (poliuretano de alta resistência para manuseio de facase outros equipamentos de corte;"}/></p>
                            <p><FormattedMessage id={"cuts.text13"} defaultMessage={"Kit de primeiros socorros."}/></p> </ul></ul>
                </div>
            </Col>

        </Row>


        <Row className={"valign-wrapper"}>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={machinery} className={"img"}/>
                </div>
            </Col>

            <Col s={10} m={10}>

                <div align="justify">

                    <p><b><FormattedMessage id={"machinery"} defaultMessage={"Acidentes com maquinário"}/></b></p>
                    <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo"}/></b></li>
                        <p><FormattedMessage id={"machinery.text1"} defaultMessage={"Capotamento de trator;"}/></p>
                        <p><FormattedMessage id={"machinery.text2"} defaultMessage={"Acidentes diversos com máquinas, aeradores e equipamentos;"}/></p>
                        <p><FormattedMessage id={"machinery.text3"} defaultMessage={"Máquinas sem equipamento de proteção."}/></p>
                        <li><b> <FormattedMessage id={"risks"} defaultMessage={"Risco/Danos à Saúde:"}/></b></li>
                        <p><FormattedMessage id={"machinery.text4"} defaultMessage={"Cortes e perfurações;"}/></p>
                        <p><FormattedMessage id={"machinery.text5"} defaultMessage={"Esmagamentos;"}/></p>
                        <p><FormattedMessage id={"machinery.text6"} defaultMessage={"Invalidez;"}/></p>

                        <p><FormattedMessage id={"machinery.text7"} defaultMessage={"Amputação de membros;"}/></p>
                        <p><FormattedMessage id={"machinery.text8"} defaultMessage={"Morte."}/></p>
                        <li><b><FormattedMessage id={"control"} defaultMessage={"Controle e prevenção:"}/></b></li>
                        <ul className={"browser-default"}>
                            <li><b><FormattedMessage id={"engineering"} defaultMessage={"Controles de engenharia:"}/></b></li>
                        <p><FormattedMessage id={"machinery.text9"} defaultMessage={"Equipar veículos (incluindo ATVs) com estruturas de proteção contra capotagem (ROPS);"}/> </p>
                        <p><FormattedMessage id={"machinery.text10"} defaultMessage={"Regular a tomada de força (PTO) traseira dos implementos rotativos na transmissão terminal do equipamento;"}/></p>
                        <p><FormattedMessage id={"machinery.text11"} defaultMessage={"Instalar protetoras em equipamentos e máquinas."}/></p>
                            <li><b><FormattedMessage id={"administration"} defaultMessage={"Administrativos e EPIs:"}/></b></li>
                        <p><FormattedMessage id={"machinery.text12"} defaultMessage={"Treinamentos para utilizar máquinas e equipamentos;"}/></p>
                        <p><FormattedMessage id={"machinery.text13"} defaultMessage={"Utilizar equipamentos de proteção apropriados;"}/></p>
                        <p><FormattedMessage id={"machinery.text14"} defaultMessage={"Evitar trabalhar sozinho;"}/></p>
                            <p><FormattedMessage id={"machinery.text15"} defaultMessage={"Não trabalhar com sono."}/></p> </ul></ul>

                </div>

            </Col>

        </Row>

        <Row className={"valign-wrapper"}>

            <Col s={2} m={2}>
                <div align="center">
                    <img src={fire_explosion_blue} className={"img"}/> </div>
            </Col>

            <Col s={10} m={10}>
                <div align="justify">
                    <p><b><FormattedMessage id={"fire"} defaultMessage={"Incêndio e Explosões"}/></b></p>
                    <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo"}/></b></li>
                        <p><FormattedMessage id={"fire.text1"} defaultMessage={"Rede elétrica comprometida;"}/></p>
                        <p><FormattedMessage id={"fire.text2"} defaultMessage={"Resíduos de cigarro;"}/></p>
                        <p><FormattedMessage id={"fire.text3"} defaultMessage={"Utilização e armazenamento incorreto de produtos inflamáveis;"}/></p>
                        <p><FormattedMessage id={"fire.text4"} defaultMessage={"Vazamento de gases;"}/></p>
                        <p><FormattedMessage id={"fire.text5"} defaultMessage={"Terminal positivos da bateria exposta em barcos."}/></p>
                        <li><b> <FormattedMessage id={"risks"} defaultMessage={"Risco/Danos à Saúde:"}/></b></li>
                        <p><FormattedMessage id={"fire.text6"} defaultMessage={"Queimaduras;"}/></p>
                        <p><FormattedMessage id={"fire.text7"} defaultMessage={"Invalidez por consequência de sequelas graves;"}/></p>
                        <p><FormattedMessage id={"fire.text8"} defaultMessage={"Morte."}/></p>
                        <li><b><FormattedMessage id={"control"} defaultMessage={"Controle e prevenção:"}/></b></li>
                        <ul className={"browser-default"}>
                            <li><b><FormattedMessage id={"elimination"} defaultMessage={"Eliminação ou substituição:"} /></b></li>
                        <p><FormattedMessage id={"fire.text9"} defaultMessage={"Substituir substâncias inflamáveis."}/></p>
                            <li><b><FormattedMessage id={"engineering"} defaultMessage={"Controles de engenharia:"}/></b></li>
                        <p><FormattedMessage id={"fire.text10"} defaultMessage={"Cobrir terminais para evitar faíscas;"}/></p>
                        <p><FormattedMessage id={"fire.text11"} defaultMessage={"Manter as fontes de faísca longe dos tanques de oxigênio e roupas;"}/></p>
                        <p><FormattedMessage id={"fire.text12"} defaultMessage={"Instale sistemas de supressão de sprinklers e exaustores."}/></p>
                            <li><b><FormattedMessage id={"administration"} defaultMessage={"Administrativos e EPIs:"}/></b></li>
                        <p><FormattedMessage id={"fire.text13"} defaultMessage={"Não fumar em torno de fontes de incêndio e explosões;"}/></p>
                        <p><FormattedMessage id={"fire.text14"} defaultMessage={"Manter substâncias incompatíveis separadas;"}/></p>
                        <p><FormattedMessage id={"fire.text15"} defaultMessage={"Treinamento e sinalização;"}/></p>
                        <p><FormattedMessage id={"fire.text16"} defaultMessage={"Detectar e reparar vazamentos;"}/></p>
                            <p><FormattedMessage id={"fire.text17"} defaultMessage={"Possuir extintores de incêndio e na validade."}/></p></ul></ul> </div> <br/> </Col>
        </Row>

        <Row className={"valign-wrapper"}>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={animals_blue} className={"img"}/>

                </div>
            </Col>

            <Col s={10} m={10}>
                <p><b><FormattedMessage id={"animals"} defaultMessage={"Animais"}/></b></p>
                <ul className={"browser-default"}>
                    <li><b><FormattedMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo"}/></b></li>
                    <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"venomous"} defaultMessage={"Peçonhentos e venenosos:"}/></b></li>
                        <p><FormattedMessage id={"animals.text1"} defaultMessage={"O perigo biológico é exacerbado quando há manipulação de animais com dentes afiados ou espinhos que podem causar cortes e picadas;"}/></p>
                        <p><FormattedMessage id={"animals.text2"} defaultMessage={"Picadas de serpente, escorpiões presentes na vegetação e água;"}/></p>
                        <p><FormattedMessage id={"animals.text3"} defaultMessage={"Contato com animais venenosos como taturana, sapos e peixes;"}/></p>
                        <li><b><FormattedMessage id={"wild"} defaultMessage={"Silvestres:"}/></b></li>
                        <p><FormattedMessage id={"animals.text4"} defaultMessage={"Mordidas e ataques de jacarés e outros animais (em regiões propícias ao surgimento desses animais)."}/> </p> </ul>
                    <li><b> <FormattedMessage id={"risks"} defaultMessage={"Risco/Danos à Saúde:"}/></b></li>
                    <p><FormattedMessage id={"animals.text5"} defaultMessage={"Picadas;"}/></p>
                    <p><FormattedMessage id={"animals.text6"} defaultMessage={"Cortes profundos;"}/></p>

                    <p><FormattedMessage id={"animals.text7"} defaultMessage={"Infecções geradas através de feridas; Reações na pele ou generalizadas (alergias), dependendo do agente causador, podendo levar à morte;"}/></p>

                    <p><FormattedMessage id={"animals.text8"} defaultMessage={"Envenenamento;"}/></p>
                    <p><FormattedMessage id={"animals.text9"} defaultMessage={"Morte."}/></p>
                    <li><b><FormattedMessage id={"control"} defaultMessage={"Controle e prevenção:"}/></b></li>
                    <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"engineering"} defaultMessage={"Controles de engenharia:"}/></b></li>
                    <p><FormattedMessage id={"animals.text10"} defaultMessage={"Controle da vegetação em torno de tanques e instalações."}/></p>
                        <li><b><FormattedMessage id={"administration"} defaultMessage={"Administrativos e EPIs:"}/></b></li>
                    <p><FormattedMessage id={"animals.text11"} defaultMessage={"Colocar à vista telefones de emergência e CIT local;"}/></p>
                        <p><FormattedMessage id={"animals.text12"} defaultMessage={"Sapatos fechados e luvas para manejo com animais."}/></p> </ul></ul>
            </Col>
        </Row>

        <Row className={"valign-wrapper"}>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={electrocution_blue} className={"img"}/>
                </div> </Col>
            <Col s={10} m={10}>

                <div align="justify">
                    <p><b><FormattedMessage id={"electrocution"} defaultMessage={"Eletrocussão"}/></b> </p>
                    <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo"}/></b></li>
                        <p><FormattedMessage id={"electrocution.text"} defaultMessage={"Contato da água com linhas de transmissão de energia elétrica;"}/> </p>
                        <p><FormattedMessage id={"electrocution.text2"}  defaultMessage={"Falta de sistemas de aterramento nas fazendas; "}/></p>
                        <p> <FormattedMessage id={"electrocution.text3"} defaultMessage={"Choques ocorridos por localidades úmidas;"}/> </p>
                        <p><FormattedMessage id={"electrocution.text4"}  defaultMessage={"Choques através da energia de reserva quando a energia principal é desligada por motivos de manutenção; "}/></p>
                        <p><FormattedMessage id={"electrocution.text5"}  defaultMessage={"Fios desencapados."}/></p>
                        <li><b> <FormattedMessage id={"risks"} defaultMessage={"Risco/Danos à Saúde:"}/></b></li>
                        <p><FormattedMessage id={"electrocution.text6"} defaultMessage={"Queimaduras;"}/> </p>
                        <p><FormattedMessage id={"electrocution.text7"} defaultMessage={"Contração muscular involuntária;"}/> </p>
                        <p><FormattedMessage id={"electrocution.text8"} defaultMessage={"Morte."}/></p>
                        <li><b><FormattedMessage id={"control"} defaultMessage={"Controle e prevenção:"}/></b></li>
                        <ul className={"browser-default"}>
                            <li><b><FormattedMessage id={"elimination"} defaultMessage={"Eliminação ou substituição:"} /></b></li>
                        <p><FormattedMessage id={"electrocution.text9"}  defaultMessage={"Utilizar interruptores de falha de circuito (GFCI) eficaz em reduzir a probabilidade de choque elétricos."}/></p>
                            <li><b><FormattedMessage id={"engineering"} defaultMessage={"Controles de engenharia:"}/></b></li>
                        <p> <FormattedMessage id={"electrocution.text10"} defaultMessage={"Assegurar o uso de fusíveis e um sistema de aterramento adequado;"}/> </p>
                        <p> <FormattedMessage id={"electrocution.text11"} defaultMessage={"Certificar que todos os cabos estão intactos e impermeabilidade;"}/> </p>
                        <p> <FormattedMessage id={"electrocution.text12"} defaultMessage={"Evitar o sobrecarregamento elétrico."}/></p>
                            <li><b><FormattedMessage id={"administration"} defaultMessage={"Administrativos e EPIs:"}/></b></li>
                        <p><FormattedMessage id={"electrocution.text13"} defaultMessage={"Tornar os trabalhadores conscientes dos riscos de choque elétrico por equipamentos próximos à água através de treinamento;"}/> </p>
                        <p><FormattedMessage id={"electrocution.text14"} defaultMessage={"As instalações elétricas devem ser revisadas e garantidas por um profissional qualificado para a função;"}/> </p>
                        <p><FormattedMessage id={"electrocution.text15"} defaultMessage={"Nunca trabalhar sozinho para que em caso de acidente, tenha alguém que possa desligar a energia;"}/></p>
                        <p><FormattedMessage id={"electrocution.text16"} defaultMessage={"A energia deve ser desligada quando o equipamento for manuseado;"}/></p>
                        <p><FormattedMessage id={"electrocution.text17"} defaultMessage={"Garantir a manutenção de equipamentos;"}/></p>
                            <p><FormattedMessage id={"electrocution.text18"} defaultMessage={"Sinalizar os equipamentos com risco de choque elétrico."}/></p>  </ul></ul>
                </div>
                <br/> </Col>
        </Row>
    </Card>
       )
   }
}

export default (Acidente);